import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { addToCartEvent } from '../Actions/Gtm.action';
const BuyButton = ({
    label,
    articleNumber,
    quantityFieldId,
    articleName,
    articleBrand,
    articleImageUrl,
    minimumQuantity,
    isMinimumQuantity,
    maximumQuantity,
    isMaximumQuantity,
    quantityStepping,
    isQuantityStepping,
    articleStatus,
    isPreorder,
    href,
    cssClass,
    onClick,
    bundles,
    priceTag,
    deliveryDays,
    deliveryText,
    variantId,
}) => {
    return (
        <Fragment>
            {articleNumber ? (
                <a
                    className={cssClass}
                    onClick={(e) => {
                        e.preventDefault();
                        onClick({
                            articleNumber,
                            quantityFieldId,
                            articleName,
                            articleBrand,
                            articleImageUrl,
                            minimumQuantity,
                            isMinimumQuantity,
                            maximumQuantity,
                            isMaximumQuantity,
                            quantityStepping,
                            isQuantityStepping,
                            articleStatus,
                            isPreorder,
                            bundles,
                            priceTag,
                            deliveryDays,
                            deliveryText,
                            variantId,
                        });
                    }}
                    href={href || '#'}
                    rel="nofollow"
                >
                    {label}
                </a>
            ) : (
                <a className={cssClass} href={href || '#'} rel="nofollow">
                    {label}
                </a>
            )}
        </Fragment>
    );
};
const errorQuantity = (id, errorName) => {
    document.getElementById(id).innerText = errorName;

    return;
};
const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = async ({
        articleNumber,
        quantityFieldId,
        minimumQuantity,
        isMinimumQuantity,
        maximumQuantity,
        isMaximumQuantity,
        quantityStepping,
        isQuantityStepping,
        bundles,
        deliveryDays,
        deliveryText,
        variantId,
    }) => {
        try {
            var buybtn = document.getElementsByTagName('buy-button')[0];

            if (buybtn) {
                var lightsourceId = buybtn.getAttribute('data-lightsourceid');
                var lampplugId = buybtn.getAttribute('data-lightplugid');
                var lightplugquantity = buybtn.getAttribute(
                    'data-lightplugquantity'
                );
                var lightsourcequantity = buybtn.getAttribute(
                    'data-lightsourcequantity'
                );
            }
            let quantity;

            if (quantityFieldId) {
                quantity = quantityFieldId
                    ? document.getElementById(quantityFieldId).value
                    : 1;
                var id = 'span-' + quantityFieldId;

                if (
                    isMinimumQuantity &&
                    isMinimumQuantity.toLowerCase().trim() === 'true' &&
                    minimumQuantity &&
                    parseInt(quantity) < parseInt(minimumQuantity)
                ) {
                    errorQuantity(
                        id,
                        translate('product.minimumquantity') +
                            ' ' +
                            minimumQuantity
                    );
                    return false;
                }

                if (
                    isMaximumQuantity &&
                    isMaximumQuantity.toLowerCase().trim() == 'true' &&
                    maximumQuantity &&
                    parseInt(quantity) > parseInt(maximumQuantity)
                ) {
                    errorQuantity(
                        id,
                        translate('product.maximumquantity') +
                            ' ' +
                            maximumQuantity
                    );
                    return false;
                }

                if (
                    isQuantityStepping &&
                    isQuantityStepping.toLowerCase().trim() === 'true' &&
                    quantityStepping &&
                    parseInt(quantity) % parseInt(quantityStepping) !== 0
                ) {
                    var addQty =
                        parseInt(quantity) % parseInt(quantityStepping);
                    errorQuantity(
                        id,
                        translate('product.multiplequantity') +
                            ' ' +
                            quantityStepping +
                            ' add ' +
                            addQty
                    );
                    return false;
                }
            } else {
                quantity = 1;
            }

            let cart;
            if (
                bundles != null &&
                bundles !== undefined &&
                bundles.length > 0
            ) {
                var bundleStringId = bundles[0].bundleId;
                for (const item of bundles) {
                    bundleStringId += ';' + item.variant;
                }

                cart = await addToCartService({
                    isBundle: true,
                    bundleStringId: bundleStringId,
                    deliveryDays,
                    deliveryText,
                    lightsourceId,
                    lampplugId,
                    lightplugquantity,
                    lightsourcequantity,
                });
            } else {
                cart = await addToCartService({
                    articleNumber,
                    quantity,
                    variantId,
                    deliveryDays,
                    deliveryText,
                    lightsourceId,
                    lampplugId,
                    lightplugquantity,
                    lightsourcequantity,
                });
            }
            await addToCartEvent(articleNumber, quantity);
            dispatch(receive(cart));

            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');

    return <Button {...props} />;
};

export default StyledButton;
